import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { BenchmarkFixingImpl } from "../model/impl/BenchmarkFixingImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class BenchmarkFixingImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: BenchmarkFixingImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.benchmarkCd != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(1),
        false,
        encodable.benchmarkCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.stamp != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(2),
        false,
        encodable.stamp,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.benchmarkDesc != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(3),
        false,
        encodable.benchmarkDesc,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.rateSourceCd != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(4),
        false,
        encodable.rateSourceCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.softCutoffOffset != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(5),
        false,
        encodable.softCutoffOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.hardCutoffOffset != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(6),
        false,
        encodable.hardCutoffOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.sweepTimeOffset != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(7),
        false,
        encodable.sweepTimeOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.deletedFg != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(8),
        false,
        encodable.deletedFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingFillTypeId != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(9),
        false,
        encodable.fixingFillTypeId,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.aliases != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        true,
        BenchmarkFixingImplEncoder.fidTypeMap.get(10),
        false,
        encodable.aliases,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.rules != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        true,
        BenchmarkFixingImplEncoder.fidTypeMap.get(11),
        false,
        encodable.rules,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.traderVisibilityOffset != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(12),
        false,
        encodable.traderVisibilityOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.effectiveTraderVisibilityOffset != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(13),
        false,
        encodable.effectiveTraderVisibilityOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.preHCOOffset != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(14),
        false,
        encodable.preHCOOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.preHedgeOffset != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(15),
        false,
        encodable.preHedgeOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.preHedgeFreq != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(16),
        false,
        encodable.preHedgeFreq,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.enableExternalRiskRoutingFg != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(17),
        false,
        encodable.enableExternalRiskRoutingFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.benchmarkPairConfigs != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        true,
        BenchmarkFixingImplEncoder.fidTypeMap.get(18),
        false,
        encodable.benchmarkPairConfigs,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        BenchmarkFixingImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,BenchmarkFixingImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.Long"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "java.lang.Long"],
    [6, "java.lang.Long"],
    [7, "java.lang.Long"],
    [8, "java.lang.Boolean"],
    [9, "com.bcdfx.model.FixingFillType"],
    [10, "java.lang.String"],
    [11, "com.bcdfx.model.BenchmarkFixingRule"],
    [12, "java.lang.Long"],
    [13, "java.lang.Long"],
    [14, "java.lang.Long"],
    [15, "java.lang.Long"],
    [16, "java.lang.Long"],
    [17, "java.lang.Boolean"],
    [18, "com.bcdfx.model.BenchmarkPairConfig"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: BenchmarkFixingImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.benchmarkCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.stamp = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.benchmarkDesc = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.rateSourceCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.softCutoffOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.hardCutoffOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.sweepTimeOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.deletedFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.FixingFillType = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.fixingFillTypeId = <CubiqTS.FixingFillType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: Array<string> = this.baseEncoder.readObject(
            false,
            true,
            BenchmarkFixingImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.aliases = <Array<string>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: Array<CubiqTS.BenchmarkFixingRule> = this.baseEncoder.readObject(
            false,
            true,
            BenchmarkFixingImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.rules = <Array<CubiqTS.BenchmarkFixingRule>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.traderVisibilityOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.effectiveTraderVisibilityOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.preHCOOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.preHedgeOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.preHedgeFreq = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.enableExternalRiskRoutingFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: Array<CubiqTS.BenchmarkPairConfig> = this.baseEncoder.readObject(
            false,
            true,
            BenchmarkFixingImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.benchmarkPairConfigs = <Array<CubiqTS.BenchmarkPairConfig>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            BenchmarkFixingImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,BenchmarkFixingImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return BenchmarkFixingImplEncoder.fidTypeMap.has(fid);
  }
}
